var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Tab, useMediaQuery, useTheme } from '@mui/material';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import FilterListIcon from '@mui/icons-material/FilterList';
import React, { useEffect, useState } from 'react';
export var DefaultTemplateListView = function (_a) {
    var newValue = _a.newValue, firstTab = _a.firstTab, secondTab = _a.secondTab, tabChange = _a.tabChange, extraTabElement = _a.extraTabElement;
    var theme = useTheme();
    var isMed = useMediaQuery(theme.breakpoints.down('md'));
    var _b = useState('1'), value = _b[0], setValue = _b[1];
    useEffect(function () {
        setValue("".concat(newValue));
    }, [newValue]);
    return (_jsx(Box, __assign({ sx: { width: '100%', typography: 'body1' } }, { children: _jsxs(TabContext, __assign({ value: value }, { children: [_jsxs(Box, __assign({ sx: { borderBottom: 1, borderColor: 'divider', display: 'flex', justifyContent: 'space-between', alignItems: 'center' } }, { children: [_jsxs(TabList, __assign({ onChange: function (event, newTab) { return tabChange === null || tabChange === void 0 ? void 0 : tabChange(newTab); }, "aria-label": "lab API tabs example" }, { children: [_jsx(Tab, { icon: _jsx(FormatListBulletedIcon, {}), iconPosition: "start", label: "Listar", value: "1" }), _jsx(Tab, { icon: _jsx(FilterListIcon, {}), iconPosition: "start", label: "Filtrar", value: "2" })] })), extraTabElement && _jsx(Box, __assign({ sx: { pr: 2 } }, { children: extraTabElement }))] })), _jsx(TabPanel, __assign({ value: "1", style: { padding: (isMed ? '0px' : '24px') } }, { children: firstTab })), _jsx(TabPanel, __assign({ value: "2", style: { padding: (isMed ? '0px' : '24px') } }, { children: secondTab }))] })) })));
};
